/* eslint-disable no-param-reassign */
import React from 'react';
import { useSwiperInit } from '@src/libs/hooks/useSwiperInit';
import { useEventsHub } from '@src/components/EventsHub/hooks';

export const useSliderHooks = ({ sliderApi }) => {
	const eventsHub = useEventsHub();
	const [isInitiated, setInitiated] = React.useState(false);

	const onInit = React.useCallback(
		(swiper) => {
			if (sliderApi) {
				const callback = sliderApi.current?.initCallback;
				sliderApi.current = swiper;
				if (callback) callback(swiper);
			}
			if (eventsHub) {
				swiper.on('slideChange', function handleSlideChange() {
					eventsHub.trigger('image-map-slide-change', {
						// eslint-disable-next-line react/no-this-in-sfc
						index: this.activeIndex,
						instance: this,
					});
				});
			}
			setInitiated(true);
		},
		[sliderApi, eventsHub],
	);

	const {
		handleSwiper,
		slideNext,
		slidePrev,
		screenCount,
		activeScreen,
		activeIndex,
		isEnd,
		apiRef,
	} = useSwiperInit({
		onInit,
	});

	const handleDotSwipe = React.useCallback(
		(i) => {
			const swiper = apiRef.current;
			if (swiper) {
				if (swiper.params?.slidesPerView === 'auto') {
					swiper.goToScreen(i);
				} else {
					swiper.slideTo(i);
				}
			}
		},
		[apiRef],
	);

	return {
		screenCount,
		activeScreen,
		activeIndex,
		isEnd,
		isInitiated,
		handleSwiper,
		handleDotSwipe,
		slideLeft: slidePrev,
		slideRight: slideNext,
	};
};
